/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

'use strict';

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;



/*****************
 ** WEBPACK FOOTER
 ** ./~/prop-types/lib/ReactPropTypesSecret.js
 ** module id = 235
 ** module chunks = 0
 **/